import { all } from 'redux-saga/effects'
import { generalSaga } from './general/saga'
import { loaderSaga } from './loader/saga'

export function* panelSaga() {
  yield all([generalSaga(), loaderSaga()])
}
